import { gql } from '@apollo/client';

export const setPaymentAttempt = gql`mutation paymentAttempt($id: String!) {
  paymentAttempt(id: $id)
}`
